export default {
  // documents: [],
  // emptyDocument: {},
  // params: {
  //   entity: [],
  //   collection: []
  // }
}